(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instruction-guide-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sensic-guide-carousel')) customElements.define('sensic-guide-carousel', class extends HTMLElement {
  connectedCallback() {
    if (this.ready || !this.hasAttribute('data-drag-scroll')) return;
    this.ready = true;
    this.addEventListener('dragstart', event => event.preventDefault());
    this.addEventListener('click', event => {
      if (this.suppressClick && event.detail > 0) {
        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
      }
    }, true);
    this.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      this.suppressClick = false;
      const startX = event.clientX, startScroll = this.scrollLeft, pointerId = event.pointerId;
      let dragged = false;
      const move = event => {
        if (event.pointerId !== pointerId) return;
        const distance = event.clientX - startX;
        if (!dragged && Math.abs(distance) < 6) return;
        if (!dragged) {
          dragged = true;
          this.classList.add('is-dragging');
          this.setPointerCapture(pointerId);
        }
        event.preventDefault();
        this.scrollLeft = startScroll - distance;
      };
      const end = event => {
        if (event.pointerId !== pointerId) return;
        this.suppressClick = dragged;
        this.classList.remove('is-dragging');
        if (this.hasPointerCapture(pointerId)) this.releasePointerCapture(pointerId);
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', end);
        window.removeEventListener('pointercancel', end);
      };
      window.addEventListener('pointermove', move, { passive: false });
      window.addEventListener('pointerup', end);
      window.addEventListener('pointercancel', end);
    });
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  
  
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[grid-recommendation]');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.querySelector('[grid-recommendation]').innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sensic-affiliate-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const styleId = 'sensic-affiliate-form-styles';
    const css = `
      section[role='dialog'] { width: 100% !important; max-width: none !important; padding: 0 !important; background: transparent !important; }
      section[role='dialog'] > div:empty { display: none !important; }
      section[role='dialog'] > div:last-child { width: 100% !important; max-width: none !important; padding: 0 !important; }
      form[data-testid='form'] { display: grid !important; grid-template-columns: repeat(2,minmax(0,1fr)) !important; gap: 16px !important; margin-top: 28px !important; }
      form[data-testid='form'] > div { min-width: 0 !important; }
      form[data-testid='form'] > div:empty { display: none !important; }
      form[data-testid='form'] > div:has(shop-lead-capture),form[data-testid='form'] > div:has(textarea),form[data-testid='form'] > button[type='submit'] { grid-column: 1/-1 !important; }
      input,textarea,button[aria-labelledby*='selector-label'] { -webkit-appearance: none !important; appearance: none !important; background: #20212b !important; border: 1px solid #343645 !important; border-radius: 12px !important; box-shadow: none !important; box-sizing: border-box !important; color: #f8f7ff !important; font-size: 15px !important; outline: none !important; transition: border-color .2s ease,box-shadow .2s ease,background .2s ease !important; width: 100% !important; }
      input:hover,textarea:hover,button[aria-labelledby*='selector-label']:hover { border-color: #4b4d60 !important; }
      input:focus,textarea:focus,button[aria-labelledby*='selector-label']:focus-visible { background: #23242f !important; border-color: #a99be8 !important; box-shadow: 0 0 0 3px rgba(169,155,232,.16) !important; }
      input[type='text'],input[type='email'],input[type='number'],button[aria-labelledby*='selector-label'] { height: 58px !important; min-height: 58px !important; }
      label[class*='_formInputFieldLabel_'] { color: #aeb0c7 !important; }
      input:focus + label[class*='_formInputFieldLabel_'],textarea:focus + label[class*='_formInputFieldLabel_'] { color: #cfc7ff !important; }
      div[class*='_selectContainer_'] { height: 58px !important; min-height: 58px !important; position: relative !important; }
      div[class*='_selectContainer_'] > p[id$='selector-label'] { color: #aeb0c7 !important; font-size: 15px !important; left: 16px !important; line-height: 1 !important; margin: 0 !important; max-width: calc(100% - 58px) !important; overflow: hidden !important; pointer-events: none !important; position: absolute !important; text-overflow: ellipsis !important; top: 50% !important; transform: translateY(-50%) !important; transition: font-size .18s ease,top .18s ease,transform .18s ease !important; white-space: nowrap !important; z-index: 2 !important; }
      div[class*='_selectContainer_'].sensic-select-has-value > p[id$='selector-label'] { color: #9295ac !important; font-size: 11px !important; top: 10px !important; transform: none !important; }
      button[aria-labelledby*='selector-label'] { padding: 20px 46px 6px 16px !important; text-align: left !important; }
      div[class*='_selectContainer_']:not(.sensic-select-has-value) button[aria-labelledby*='selector-label'] { padding-top: 6px !important; }
      button[aria-labelledby*='selector-label'] svg path { fill: #cfc7ff !important; }
      form[data-testid='form'] > div:has(> textarea)::before { display: none !important; }
      textarea { min-height: 160px !important; padding: 22px 16px 14px !important; resize: vertical !important; }
      button[type='submit'] { align-items: center !important; border-radius: 12px !important; box-sizing: border-box !important; color: #fff !important; display: flex !important; font-weight: 750 !important; height: 58px !important; justify-content: center !important; min-height: 58px !important; padding: 0 24px !important; text-align: center !important; }
      @media (max-width:749px) { form[data-testid='form'] { grid-template-columns: 1fr !important; } form[data-testid='form'] > div,form[data-testid='form'] > button[type='submit'] { grid-column: 1 !important; } }
    `;
    const apply = () => {
      document.querySelectorAll('.sensic-affiliate__shopify-form shopify-forms-embed').forEach((host) => {
        if (!host.shadowRoot) return;
        if (!host.shadowRoot.getElementById(styleId)) { const style = document.createElement('style'); style.id = styleId; style.textContent = css; host.shadowRoot.appendChild(style); }
        const syncSelectState = () => { host.shadowRoot.querySelectorAll("div[class*='_selectContainer_']").forEach((container) => { const value = container.querySelector("span[id$='selector-value']"); container.classList.toggle('sensic-select-has-value', Boolean(value && value.textContent.trim())); }); };
        syncSelectState();
        if (!host.dataset.sensicAffiliateObserver) { new MutationObserver(syncSelectState).observe(host.shadowRoot,{ childList:true,subtree:true,characterData:true }); host.dataset.sensicAffiliateObserver = 'true'; }
      });
    };
    apply();
    new MutationObserver(apply).observe(document.documentElement,{ childList:true,subtree:true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sensic-affiliate"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const styleId = 'sensic-affiliate-form-styles';
    const css = `
      section[role='dialog'] { width: 100% !important; max-width: none !important; padding: 0 !important; background: transparent !important; }
      section[role='dialog'] > div:empty { display: none !important; }
      section[role='dialog'] > div:last-child { width: 100% !important; max-width: none !important; padding: 0 !important; }
      form[data-testid='form'] { display: grid !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; gap: 16px !important; margin-top: 28px !important; }
      form[data-testid='form'] > div { min-width: 0 !important; }
      form[data-testid='form'] > div:empty { display: none !important; }
      form[data-testid='form'] > div:has(shop-lead-capture),
      form[data-testid='form'] > div:has(textarea),
      form[data-testid='form'] > button[type='submit'] { grid-column: 1 / -1 !important; }
      input,
      textarea,
      button[aria-labelledby*='selector-label'] {
        -webkit-appearance: none !important;
        appearance: none !important;
        background: #20212b !important;
        border: 1px solid #343645 !important;
        border-radius: 12px !important;
        box-shadow: none !important;
        box-sizing: border-box !important;
        color: #f8f7ff !important;
        font-size: 15px !important;
        outline: none !important;
        transition: border-color .2s ease, box-shadow .2s ease, background .2s ease !important;
        width: 100% !important;
      }
      input:hover,
      textarea:hover,
      button[aria-labelledby*='selector-label']:hover { border-color: #4b4d60 !important; }
      input:focus,
      textarea:focus,
      button[aria-labelledby*='selector-label']:focus-visible {
        background: #23242f !important;
        border-color: #a99be8 !important;
        box-shadow: 0 0 0 3px rgba(169,155,232,.16) !important;
      }
      input[type='text'],
      input[type='email'],
      input[type='number'],
      button[aria-labelledby*='selector-label'] { height: 58px !important; min-height: 58px !important; }
      label[class*='_formInputFieldLabel_'] { color: #aeb0c7 !important; }
      input:focus + label[class*='_formInputFieldLabel_'],
      textarea:focus + label[class*='_formInputFieldLabel_'] { color: #cfc7ff !important; }
      div[class*='_selectContainer_'] { height: 58px !important; min-height: 58px !important; position: relative !important; }
      div[class*='_selectContainer_'] > p[id$='selector-label'] {
        color: #aeb0c7 !important;
        font-size: 15px !important;
        left: 16px !important;
        line-height: 1 !important;
        margin: 0 !important;
        max-width: calc(100% - 58px) !important;
        overflow: hidden !important;
        pointer-events: none !important;
        position: absolute !important;
        text-overflow: ellipsis !important;
        top: 50% !important;
        transform: translateY(-50%) !important;
        transition: font-size .18s ease, top .18s ease, transform .18s ease !important;
        white-space: nowrap !important;
        z-index: 2 !important;
      }
      div[class*='_selectContainer_'].sensic-select-has-value > p[id$='selector-label'] {
        color: #9295ac !important;
        font-size: 11px !important;
        top: 10px !important;
        transform: none !important;
      }
      button[aria-labelledby*='selector-label'] { padding: 20px 46px 6px 16px !important; text-align: left !important; }
      div[class*='_selectContainer_']:not(.sensic-select-has-value) button[aria-labelledby*='selector-label'] { padding-top: 6px !important; }
      button[aria-labelledby*='selector-label'] svg path { fill: #cfc7ff !important; }
      form[data-testid='form'] > div:has(> textarea)::before { display: none !important; }
      textarea { min-height: 160px !important; padding: 22px 16px 14px !important; resize: vertical !important; }
      button[type='submit'] {
        align-items: center !important;
        border-radius: 12px !important;
        box-sizing: border-box !important;
        color: #ffffff !important;
        display: flex !important;
        font-weight: 750 !important;
        height: 58px !important;
        justify-content: center !important;
        min-height: 58px !important;
        padding: 0 24px !important;
        text-align: center !important;
      }
      @media (max-width: 749px) { form[data-testid='form'] { grid-template-columns: 1fr !important; } form[data-testid='form'] > div, form[data-testid='form'] > button[type='submit'] { grid-column: 1 !important; } }
    `;

    const apply = () => {
      document.querySelectorAll('.sensic-affiliate__shopify-form shopify-forms-embed').forEach((host) => {
        if (!host.shadowRoot) return;

        if (!host.shadowRoot.getElementById(styleId)) {
          const style = document.createElement('style');
          style.id = styleId;
          style.textContent = css;
          host.shadowRoot.appendChild(style);
        }

        const syncSelectState = () => {
          host.shadowRoot.querySelectorAll("div[class*='_selectContainer_']").forEach((container) => {
            const value = container.querySelector("span[id$='selector-value']");
            container.classList.toggle('sensic-select-has-value', Boolean(value && value.textContent.trim()));
          });
        };

        syncSelectState();
        if (!host.dataset.sensicAffiliateObserver) {
          new MutationObserver(syncSelectState).observe(host.shadowRoot, { childList: true, subtree: true, characterData: true });
          host.dataset.sensicAffiliateObserver = 'true';
        }
      });
    };

    apply();
    new MutationObserver(apply).observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sensic-contact-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const styleId = 'sensic-contact-form-styles';
    const css = `
      section[role='dialog'] {
        width: 100% !important;
        max-width: none !important;
        padding: 0 !important;
        background: transparent !important;
      }

      section[role='dialog'] > div:empty {
        display: none !important;
      }

      section[role='dialog'] > div:last-child {
        width: 100% !important;
        max-width: none !important;
        padding: 0 !important;
      }

      section[role='dialog']:has(form[data-testid='form']) h2 + div {
        display: none !important;
      }

      [id='custom#what_can_we_help_with-selector-value']:empty::before {
        content: 'Product advice';
        color: var(--contact-text);
      }

      [id='custom#what_can_we_help_with-selector-label'] {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        padding: 0 !important;
        margin: -1px !important;
        overflow: hidden !important;
        clip: rect(0, 0, 0, 0) !important;
        white-space: nowrap !important;
        border: 0 !important;
      }

      section[role='dialog'].sensic-contact-success {
        box-sizing: border-box !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        min-height: 360px !important;
        padding: 42px 24px !important;
        text-align: center !important;
      }

      section[role='dialog'].sensic-contact-success > div:last-child {
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        width: min(100%, 620px) !important;
      }

      section[role='dialog'].sensic-contact-success h2 {
        display: grid !important;
        justify-items: center !important;
        gap: 22px !important;
        margin: 0 !important;
        color: var(--contact-text) !important;
        font-size: clamp(30px, 4vw, 44px) !important;
        line-height: 1.08 !important;
        letter-spacing: -.035em !important;
      }

      section[role='dialog'].sensic-contact-success h2::before {
        content: '✓';
        display: grid;
        place-items: center;
        width: 68px;
        height: 68px;
        border-radius: 50%;
        background: color-mix(in srgb, var(--contact-accent) 18%, transparent);
        color: var(--contact-accent);
        box-shadow: 0 0 0 1px color-mix(in srgb, var(--contact-accent) 48%, transparent);
        font-size: 31px;
        font-weight: 800;
        letter-spacing: 0;
      }

      section[role='dialog'].sensic-contact-success .sensic-contact-success-copy {
        max-width: 500px !important;
        margin: 18px auto 0 !important;
        color: var(--contact-muted) !important;
        font-size: 16px !important;
        line-height: 1.65 !important;
      }

      form[data-testid='form'] {
        display: grid !important;
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        gap: 18px 16px !important;
        margin-top: 28px !important;
      }

      form[data-testid='form'] > div:has(shop-lead-capture) {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        overflow: hidden !important;
      }

      form[data-testid='form'] > div:has(input[id='custom#order_number']) {
        grid-column: 2;
        grid-row: 2;
      }

      form[data-testid='form'] > div:has(button[aria-labelledby*='what_can_we_help_with']) {
        grid-column: 1;
        grid-row: 2;
      }

      form[data-testid='form'] > div:has(textarea),
      form[data-testid='form'] > div:has(input[type='file']),
      form[data-testid='form'] > button[type='submit'] {
        grid-column: 1 / -1;
      }

      input[type='text'],
      button[aria-labelledby*='selector-label'] {
        box-sizing: border-box !important;
        height: 58px !important;
        min-height: 58px !important;
        border-radius: 12px !important;
      }

      textarea {
        box-sizing: border-box !important;
        min-height: 150px !important;
        border-radius: 12px !important;
        resize: vertical !important;
      }

      button[aria-labelledby*='selector-label'] svg path {
        fill: var(--contact-text) !important;
      }

      div:has(> label > input[type='file']) {
        box-sizing: border-box !important;
        height: 58px !important;
        min-height: 58px !important;
        border-radius: 12px !important;
        background: var(--contact-surface-soft) !important;
        box-shadow: 0 0 0 1px var(--contact-border) !important;
      }

      div:has(> label > input[type='file']) > div {
        padding: 8px !important;
      }

      div:has(> label > input[type='file']) > div span {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        min-height: 40px !important;
        padding: 0 20px !important;
        border-radius: 999px !important;
        background: var(--button-background-color) !important;
        color: #ffffff !important;
        font-weight: 700 !important;
      }

      button[type='submit'] {
        box-sizing: border-box !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        height: 58px !important;
        min-height: 58px !important;
        color: #ffffff !important;
        text-align: center !important;
        font-weight: 700 !important;
        transition: transform .2s ease, filter .2s ease !important;
      }

      button[type='submit']:hover {
        filter: brightness(1.08) !important;
        transform: translateY(-1px) !important;
      }

      @media (max-width: 749px) {
        form[data-testid='form'] {
          grid-template-columns: minmax(0, 1fr) !important;
        }

        form[data-testid='form'] > div,
        form[data-testid='form'] > button[type='submit'] {
          grid-column: 1 !important;
          grid-row: auto !important;
        }
      }
    `;

    const applyStyles = () => {
      document.querySelectorAll('.sensic-contact__shopify-form shopify-forms-embed').forEach((host) => {
        if (!host.shadowRoot) return;

        if (!host.shadowRoot.getElementById(styleId)) {
          const style = document.createElement('style');
          style.id = styleId;
          style.textContent = css;
          host.shadowRoot.appendChild(style);
        }

        const enhanceFormState = () => {
          const heading = Array.from(host.shadowRoot.querySelectorAll('h2')).find((element) => element.textContent.trim() === 'Message sent');
          if (!heading) return;

          const dialog = heading.closest("section[role='dialog']");
          if (!dialog) return;

          dialog.classList.add('sensic-contact-success');
          heading.textContent = 'Thanks — your message is on its way.';

          let copy = heading.parentElement.querySelector('.sensic-contact-success-copy');
          if (!copy && heading.nextElementSibling && ['DIV', 'P'].includes(heading.nextElementSibling.tagName)) {
            copy = heading.nextElementSibling;
            copy.classList.add('sensic-contact-success-copy');
          }
          if (!copy) {
            copy = document.createElement('p');
            copy.className = 'sensic-contact-success-copy';
            heading.insertAdjacentElement('afterend', copy);
          }
          copy.textContent = 'Thanks for contacting Sensic. Our support team will reply within one business day.';
        };

        enhanceFormState();

        if (!host.dataset.sensicStateObserver) {
          const shadowObserver = new MutationObserver(enhanceFormState);
          shadowObserver.observe(host.shadowRoot, { childList: true, subtree: true });
          host.dataset.sensicStateObserver = 'true';
        }
      });
    };

    applyStyles();
    const observer = new MutationObserver(applyStyles);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sensic-guides-faq"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sensic-guides-faq'))customElements.define('sensic-guides-faq',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.tabs=[...this.querySelectorAll('[role=tab]')];this.panels=[...this.querySelectorAll('[role=tabpanel]')];const mobile=matchMedia('(max-width:749px)');const orientation=()=>this.querySelector('[role=tablist]').setAttribute('aria-orientation',mobile.matches?'horizontal':'vertical');orientation();mobile.addEventListener('change',orientation);this.tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>this.activate(index));tab.addEventListener('keydown',event=>{let next=index;if(['ArrowDown','ArrowRight'].includes(event.key))next=(index+1)%this.tabs.length;else if(['ArrowUp','ArrowLeft'].includes(event.key))next=(index-1+this.tabs.length)%this.tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=this.tabs.length-1;else return;event.preventDefault();this.activate(next);this.tabs[next].focus()})})}
activate(index){this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;this.panels[i].hidden=i!==index})}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sensic-mic-compatibility"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sensic-mic-table')){customElements.define('sensic-mic-table',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.body=this.querySelector('[data-table-body]');this.rows=[...this.querySelectorAll('[data-mic-row]')];this.search=this.querySelector('[data-search]');this.brand=this.querySelector('[data-brand]');this.sort=this.querySelector('[data-sort]');this.more=this.querySelector('[data-more]');this.pageSize=window.matchMedia('(max-width:899px)').matches?10:12;this.limit=this.pageSize;this.search.addEventListener('input',()=>{this.limit=this.pageSize;this.update()});this.brand.addEventListener('change',()=>{this.limit=this.pageSize;this.update()});this.sort.addEventListener('change',()=>{this.limit=this.pageSize;this.sortRows();this.update()});this.more.addEventListener('click',()=>{this.limit+=this.pageSize;this.update()});this.sortRows();this.update()}
normal(text){return text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ø/g,'o').replace(/[^a-z0-9+]/g,'')}
sortRows(){const alpha=(a,b)=>a.dataset.brandName.localeCompare(b.dataset.brandName,undefined,{sensitivity:'base'})||a.dataset.model.localeCompare(b.dataset.model,undefined,{numeric:true,sensitivity:'base'});this.rows.sort((a,b)=>this.sort.value==='alphabetical'?alpha(a,b):(Number(a.dataset.popularity)-Number(b.dataset.popularity)||alpha(a,b)));this.rows.forEach(row=>this.body.append(row))}
update(){const query=this.normal(this.search.value),brand=this.brand.value;let count=0;this.rows.forEach(row=>{const match=(!brand||row.dataset.brandName===brand)&&this.normal(row.dataset.brandName+' '+row.dataset.model).includes(query);if(match)count++;row.hidden=!match||count>this.limit});this.querySelector('[data-count]').textContent=count;this.querySelector('[data-empty]').hidden=count>0;this.more.hidden=count<=this.limit;this.querySelector('.smt-table-wrap').hidden=count===0}
})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sensic-warranty"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const styleId = 'sensic-warranty-form-styles';
    const css = `
      section[role='dialog'] {
        width: 100% !important;
        max-width: none !important;
        padding: 0 !important;
        background: transparent !important;
      }

      section[role='dialog'] > div:empty {
        display: none !important;
      }

      section[role='dialog'] > div:last-child {
        width: 100% !important;
        max-width: none !important;
        padding: 0 !important;
      }

      section[role='dialog'] h2 {
        margin: 0 !important;
        color: var(--warranty-ink) !important;
        font-size: clamp(28px, 3vw, 36px) !important;
        line-height: 1.1 !important;
        letter-spacing: -.03em !important;
      }

      form[data-testid='form'] {
        display: grid !important;
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        gap: 18px 16px !important;
        margin-top: 28px !important;
      }

      form[data-testid='form'] > div:has(shop-lead-capture) {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        overflow: hidden !important;
      }

      form[data-testid='form'] > div:has(input[id='first_name']) {
        grid-column: 1;
        grid-row: 1;
      }

      form[data-testid='form'] > div:has(input[id='last_name']) {
        grid-column: 2;
        grid-row: 1;
      }

      form[data-testid='form'] > div:has(input[id='email']) {
        grid-column: 1;
        grid-row: 2;
      }

      form[data-testid='form'] > div:has(input[id='custom#order_number']) {
        grid-column: 2;
        grid-row: 2;
      }

      form[data-testid='form'] > div:has(button[aria-labelledby*='where_did_you_purchase']),
      form[data-testid='form'] > fieldset,
      form[data-testid='form'] > button[type='submit'] {
        grid-column: 1 / -1;
      }

      input[type='text'],
      button[aria-labelledby*='selector-label'] {
        box-sizing: border-box !important;
        height: 58px !important;
        min-height: 58px !important;
        border: 0 !important;
        border-radius: 12px !important;
        background: var(--warranty-surface-soft) !important;
        color: var(--warranty-ink) !important;
        box-shadow: 0 0 0 1px var(--warranty-border) !important;
      }

      input[type='text']:focus,
      button[aria-labelledby*='selector-label']:focus-visible {
        outline: 0 !important;
        box-shadow: 0 0 0 2px var(--warranty-accent) !important;
      }

      label,
      legend,
      p[id$='selector-label'] {
        color: var(--warranty-ink) !important;
      }

      input[type='text'] + label {
        color: var(--warranty-muted) !important;
      }

      button[aria-labelledby*='selector-label'] svg path {
        fill: var(--warranty-ink) !important;
      }

      [id='custom#where_did_you_purchase-selector-value']:empty::before {
        content: 'Sensic website';
        color: var(--warranty-ink);
      }

      fieldset {
        min-width: 0 !important;
        margin: 2px 0 0 !important;
        padding: 0 !important;
        border: 0 !important;
      }

      fieldset > div {
        display: grid !important;
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        gap: 12px !important;
        margin-top: 10px !important;
      }

      fieldset > div > label {
        box-sizing: border-box !important;
        display: flex !important;
        align-items: center !important;
        gap: 12px !important;
        min-height: 58px !important;
        padding: 12px 16px !important;
        border-radius: 12px !important;
        background: var(--warranty-surface-soft) !important;
        box-shadow: 0 0 0 1px var(--warranty-border) !important;
        cursor: pointer !important;
      }

      fieldset input[type='radio'] {
        width: 18px !important;
        height: 18px !important;
        margin: 0 !important;
        accent-color: var(--warranty-accent) !important;
      }

      fieldset > div > label:has(input:checked) {
        background: color-mix(in srgb, var(--warranty-accent) 13%, var(--warranty-surface-soft)) !important;
        box-shadow: 0 0 0 2px var(--warranty-accent) !important;
      }

      button[type='submit'] {
        box-sizing: border-box !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        height: 58px !important;
        min-height: 58px !important;
        border-radius: 999px !important;
        color: #ffffff !important;
        text-align: center !important;
        font-weight: 700 !important;
        transition: transform .2s ease, filter .2s ease !important;
      }

      button[type='submit']:hover {
        filter: brightness(1.08) !important;
        transform: translateY(-1px) !important;
      }

      @media (max-width: 749px) {
        form[data-testid='form'],
        fieldset > div {
          grid-template-columns: minmax(0, 1fr) !important;
        }

        form[data-testid='form'] > div,
        form[data-testid='form'] > fieldset,
        form[data-testid='form'] > button[type='submit'] {
          grid-column: 1 !important;
          grid-row: auto !important;
        }
      }
    `;

    const applyStyles = () => {
      document.querySelectorAll('.sensic-warranty__shopify-form shopify-forms-embed').forEach((host) => {
        if (!host.shadowRoot) return;

        if (!host.shadowRoot.getElementById(styleId)) {
          const style = document.createElement('style');
          style.id = styleId;
          style.textContent = css;
          host.shadowRoot.appendChild(style);
        }

        const selectSensicWebsite = () => {
          const value = host.shadowRoot.querySelector("[id='custom#where_did_you_purchase-selector-value']");
          if (!value || value.textContent.trim() !== '') return;

          const option = host.shadowRoot.querySelector("[id='select-custom#where_did_you_purchase-Sensic website']");
          if (option) {
            option.click();
            return;
          }

          const toggle = host.shadowRoot.querySelector("button[aria-labelledby*='where_did_you_purchase']");
          if (toggle && toggle.getAttribute('aria-expanded') === 'false') toggle.click();
        };

        selectSensicWebsite();

        if (!host.dataset.sensicPurchaseObserver) {
          const shadowObserver = new MutationObserver(selectSensicWebsite);
          shadowObserver.observe(host.shadowRoot, { childList: true, subtree: true });
          host.dataset.sensicPurchaseObserver = 'true';
        }
      });
    };

    applyStyles();
    const observer = new MutationObserver(applyStyles);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-oddit-home-product-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sv-oddit-home-hero')) {
    customElements.define('sv-oddit-home-hero', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-sv-home-tab]'));
        this.slides = Array.from(this.querySelectorAll('[data-sv-home-slide]'));
        this.playback = this.querySelector('[data-sv-home-playback]');
        this.previousButton = this.querySelector('[data-sv-home-previous]');
        this.nextButton = this.querySelector('[data-sv-home-next]');
        this.activeIndex = Math.max(0, this.tabs.findIndex((tab) => tab.classList.contains('is-active')));
        this.paused = false;
        this.timer = null;
        this.timerStartedAt = 0;
        this.timerRemaining = 0;
        this.pointerStart = null;
        this.isVisible = false;
        this.mediaEvents = new AbortController();
        this.mobileVideoQuery = window.matchMedia('(max-width: 749px)');
        this.mobileVideoQuery.addEventListener('change', () => {
          this.slides.forEach((slide) => {
            const video = slide.querySelector('video[data-sv-home-mobile-src]');
            if (!video) return;
            video.pause();
            video.removeAttribute('src');
            video.querySelectorAll(':scope > source').forEach((source) => source.remove());
            delete video.dataset.svHomeSource;
            delete video.dataset.svHomeReady;
            delete video.dataset.svHomeFailed;
            video.load();
          });
          this.clearProgress();
          this.playActiveVideo();
          this.startTimer();
        }, { signal: this.mediaEvents.signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.pauseAllVideos();
            this.pauseTimer();
            this.classList.add('is-playback-suspended');
          } else if (this.isVisible) {
            this.classList.remove('is-playback-suspended');
            this.playActiveVideo();
            this.resumeTimer();
          }
        }, { signal: this.mediaEvents.signal });
        this.pendingVideoReset = new WeakSet();
        this.videoFrame = null;
        this.slides.forEach((slide) => {
          const video = slide.querySelector('video');
          if (!video) return;
          const options = { signal: this.mediaEvents.signal };
          video.addEventListener('loadedmetadata', () => {
            if (this.pendingVideoReset.has(video)) {
              this.resetVideo(video);
              if (this.slides[this.activeIndex] === slide) this.playActiveVideo();
            }
            this.syncVideoProgress(video);
          }, options);
          ['timeupdate', 'durationchange', 'seeked'].forEach((event) => {
            video.addEventListener(event, () => this.syncVideoProgress(video), options);
          });
          video.addEventListener('playing', () => {
            if (this.slides[this.activeIndex] !== slide || this.paused || !this.isVisible) {
              video.pause();
              return;
            }
            if (video.hasAttribute('data-sv-home-mobile-src')) video.dataset.svHomeReady = 'true';
            this.startVideoProgress(video);
          }, options);
          if (video.hasAttribute('data-sv-home-mobile-src')) {
            video.addEventListener('error', () => {
              if (!video.error) return;
              video.dataset.svHomeFailed = 'true';
              delete video.dataset.svHomeReady;
              if (this.slides[this.activeIndex] === slide) this.startTimer();
            }, options);
          }
          video.addEventListener('ended', () => {
            if (this.slides[this.activeIndex] !== slide || this.paused || !this.isVisible) return;
            this.syncVideoProgress(video);
            if (this.dataset.autoplay === 'true' && this.tabs.length > 1 && !window.Shopify?.designMode) {
              this.activate(this.activeIndex + 1, false);
            } else {
              this.resetVideo(video);
              this.playActiveVideo();
            }
          }, options);
        });
        this.style.setProperty('--sv-home-tabs', this.tabs.length || 1);

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(index, true));
          tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index));
        });

        this.stage = this.querySelector('.sv-oddit-home-hero__stage');
        this.onSwipeStart = (event) => {
          if (event.pointerType === 'mouse' || event.target.closest('a, button, [data-sv-home-tabs]')) return;
          this.pointerStart = {
            id: event.pointerId,
            x: event.clientX,
            y: event.clientY,
            time: performance.now()
          };
          this.stage?.setPointerCapture?.(event.pointerId);
        };
        this.onSwipeEnd = (event) => {
          if (!this.pointerStart || event.pointerId !== this.pointerStart.id) return;
          const distanceX = event.clientX - this.pointerStart.x;
          const distanceY = event.clientY - this.pointerStart.y;
          const elapsed = performance.now() - this.pointerStart.time;
          const threshold = Math.min(72, Math.max(44, (this.stage?.clientWidth || 360) * .12));
          this.pointerStart = null;
          if (elapsed > 900 || Math.abs(distanceX) < threshold || Math.abs(distanceY) > Math.abs(distanceX) * .7) return;
          this.activate(this.activeIndex + (distanceX < 0 ? 1 : -1), true);
        };
        this.onSwipeCancel = () => {
          this.pointerStart = null;
        };
        this.stage?.addEventListener('pointerdown', this.onSwipeStart, { passive: true });
        this.stage?.addEventListener('pointerup', this.onSwipeEnd, { passive: true });
        this.stage?.addEventListener('pointercancel', this.onSwipeCancel, { passive: true });

        this.playback?.addEventListener('click', () => this.setPaused(!this.paused));
        this.previousButton?.addEventListener('click', () => this.activate(this.activeIndex - 1, true));
        this.nextButton?.addEventListener('click', () => this.activate(this.activeIndex + 1, true));
        this.editorHandler = (event) => {
          const blockId = event.target?.dataset?.blockId;
          const index = this.slides.findIndex((slide) => slide.dataset.blockId === blockId);
          if (index >= 0) this.activate(index, true);
        };
        this.addEventListener('shopify:block:select', this.editorHandler);

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.isVisible = true;
              this.playActiveVideo();
              this.classList.remove('is-playback-suspended');
              this.resumeTimer();
            } else {
              this.isVisible = false;
              this.pauseAllVideos();
              this.pauseTimer();
              this.classList.add('is-playback-suspended');
            }
          });
        }, { threshold: .35 });
        this.observer.observe(this);
        this.activate(this.activeIndex, false);
      }

      disconnectedCallback() {
        this.stopTimer();
        this.pauseAllVideos();
        this.mediaEvents?.abort();
        this.observer?.disconnect();
        this.removeEventListener('shopify:block:select', this.editorHandler);
        this.stage?.removeEventListener('pointerdown', this.onSwipeStart);
        this.stage?.removeEventListener('pointerup', this.onSwipeEnd);
        this.stage?.removeEventListener('pointercancel', this.onSwipeCancel);
      }

      activate(index, userInitiated) {
        if (!this.tabs.length || !this.slides.length) return;
        const nextIndex = (index + this.tabs.length) % this.tabs.length;
        const nextTab = this.tabs[nextIndex];
        nextTab?.classList.add('is-resetting-progress');
        this.stopTimer();
        this.clearProgress();
        this.timerRemaining = 0;
        this.activeIndex = nextIndex;

        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === nextIndex;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });

        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === nextIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.toggleAttribute('inert', !active);
          if (!active) this.pauseSlide(slide, true);
        });

        const video = this.slides[nextIndex]?.querySelector('video');
        if (video) {
          this.resetVideo(video);
          this.syncVideoProgress(video);
        }
        if (userInitiated && this.paused) this.setPaused(false);
        this.playActiveVideo();
        this.startTimer();
      }

      resetVideo(video) {
        video.pause();
        if (video.readyState === 0) this.pendingVideoReset.add(video);
        else this.pendingVideoReset.delete(video);
        try { video.currentTime = 0; } catch (_) { this.pendingVideoReset.add(video); }
      }

      syncVideoProgress(video) {
        if (video.dataset.svHomeFailed) return;
        if (this.slides[this.activeIndex]?.querySelector('video') !== video) return;
        const duration = video.duration;
        const progress = Number.isFinite(duration) && duration > 0 ? video.currentTime / duration : 0;
        const tab = this.tabs[this.activeIndex];
        tab?.classList.add('is-video-progress');
        const bar = tab?.querySelector('.sv-oddit-home-hero__tab-progress > span');
        if (bar) bar.style.transform = `scaleX(${Math.min(1, Math.max(0, progress))})`;
        tab?.classList.remove('is-resetting-progress');
      }

      startVideoProgress(video) {
        this.syncVideoProgress(video);
      }

      sendPlayerCommand(iframe, command) {
        if (!iframe?.contentWindow) return;
        const provider = iframe.dataset.provider;
        if (provider === 'youtube') {
          iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: command === 'play' ? 'playVideo' : 'pauseVideo', args: [] }), '*');
        } else if (provider === 'vimeo') {
          iframe.contentWindow.postMessage({ method: command }, '*');
        }
      }

      pauseSlide(slide, unload = false) {
        slide.querySelector('video')?.pause();
        const iframe = slide.querySelector('iframe[data-src]');
        if (!iframe?.getAttribute('src')) return;
        if (unload) iframe.removeAttribute('src');
        else this.sendPlayerCommand(iframe, 'pause');
      }

      pauseAllVideos(unload = false) {
        this.slides.forEach((slide) => this.pauseSlide(slide, unload));
      }

      playActiveVideo() {
        if (this.paused || !this.isVisible || document.hidden) return;
        const activeSlide = this.slides[this.activeIndex];
        if (!activeSlide) return;
        const video = activeSlide.querySelector('video');
        const usesMobileVideo = this.mobileVideoQuery.matches && video?.hasAttribute('data-sv-home-mobile-src');
        const poster = activeSlide.querySelector('.sv-oddit-home-hero__poster img');
        if (!usesMobileVideo && poster && !poster.complete && !activeSlide.dataset.svPosterReady) {
          if (activeSlide.dataset.svPosterPending) return;
          activeSlide.dataset.svPosterPending = 'true';
          poster.decode().catch(() => {}).finally(() => {
            activeSlide.dataset.svPosterReady = 'true';
            delete activeSlide.dataset.svPosterPending;
            if (this.isConnected && this.slides[this.activeIndex] === activeSlide) this.playActiveVideo();
          });
          return;
        }
        const iframe = activeSlide.querySelector('iframe[data-src]');
        if (iframe && !iframe.getAttribute('src')) iframe.setAttribute('src', iframe.dataset.src);
        else if (iframe) this.sendPlayerCommand(iframe, 'play');
        if (video && !video.dataset.svHomeFailed) {
          if (video.hasAttribute('data-sv-home-mobile-src') && !video.dataset.svHomeSource) {
            if (this.mobileVideoQuery.matches) {
              video.src = video.dataset.svHomeMobileSrc;
              video.dataset.svHomeSource = 'mobile';
            } else {
              const sources = video.querySelector('template[data-sv-home-desktop-sources]');
              if (!sources) return;
              sources.content.querySelectorAll('source').forEach((source) => {
                video.append(source.cloneNode(true));
              });
              video.dataset.svHomeSource = 'desktop';
            }
            this.pendingVideoReset.add(video);
            video.load();
          }
          video.play().catch(() => {});
        }
      }

      setPaused(paused) {
        this.paused = paused;
        this.classList.toggle('is-paused', paused);
        if (this.playback) {
          this.playback.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        }
        if (paused) {
          this.pauseAllVideos();
          this.pauseTimer();
        } else {
          this.playActiveVideo();
          this.resumeTimer();
        }
      }

      startTimer() {
        this.stopTimer();
        const video = this.slides[this.activeIndex]?.querySelector('video');
        if (video && !video.dataset.svHomeFailed) {
          this.syncVideoProgress(video);
          this.startVideoProgress(video);
          return;
        }
        if (this.dataset.autoplay !== 'true' || this.paused || !this.isVisible || this.tabs.length < 2 || Shopify.designMode) return;
        const activeTab = this.tabs[this.activeIndex];
        const interval = Number(activeTab?.dataset.progressDuration) || Number(this.dataset.interval) || 15000;
        this.clearProgress();
        activeTab?.style.setProperty('--sv-home-progress-duration', `${interval}ms`);
        if (activeTab) {
          void activeTab.offsetWidth;
          activeTab.classList.add('is-progressing');
          activeTab.classList.remove('is-resetting-progress');
        }
        this.timer = window.setTimeout(() => this.activate(this.activeIndex + 1, false), interval);
        this.timerStartedAt = performance.now();
        this.timerRemaining = interval;
      }

      pauseTimer() {
        if (this.timer) {
          this.timerRemaining = Math.max(0, this.timerRemaining - (performance.now() - this.timerStartedAt));
        }
        this.stopTimer();
      }

      resumeTimer() {
        const video = this.slides[this.activeIndex]?.querySelector('video');
        if (video && !video.dataset.svHomeFailed) {
          this.startVideoProgress(video);
          return;
        }
        if (this.dataset.autoplay !== 'true' || !this.isVisible || this.tabs.length < 2 || Shopify.designMode) return;
        if (this.timerRemaining <= 0) {
          this.startTimer();
          return;
        }
        this.timerStartedAt = performance.now();
        this.timer = window.setTimeout(() => this.activate(this.activeIndex + 1, false), this.timerRemaining);
      }

      stopTimer() {
        if (this.timer) window.clearTimeout(this.timer);
        this.timer = null;
        if (this.videoFrame !== null) cancelAnimationFrame(this.videoFrame);
        this.videoFrame = null;
      }

      clearProgress() {
        this.tabs.forEach((tab) => {
          tab.classList.remove('is-progressing', 'is-video-progress');
          tab.querySelector('.sv-oddit-home-hero__tab-progress > span')?.style.removeProperty('transform');
        });
      }

      onTabKeydown(event, index) {
        let nextIndex = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex += 1;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex -= 1;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.activate(nextIndex, true);
        this.tabs[this.activeIndex]?.focus();
      }
    });
  }

  const svOdditSyncHomeFeatureButton = (featureSection) => {
    const button = featureSection.querySelector('a[class*="feature-button-"]');
    const activeContent = featureSection.querySelector('[class*="feature-text-content-"].active');
    const productLink = activeContent?.querySelector('a[href*="/products/"]');
    if (!button || !productLink) return;
    button.href = productLink.href;
  };

  const svOdditInitHomeFeatureLinks = (scope = document) => {
    scope.querySelectorAll('div[class*=" feature-"]').forEach((featureSection) => {
      if (featureSection.dataset.svOdditProductLinksReady === 'true') return;
      if (!featureSection.querySelector('[class*="feature-text-content-"]')) return;
      featureSection.dataset.svOdditProductLinksReady = 'true';
      svOdditSyncHomeFeatureButton(featureSection);
      const observer = new MutationObserver(() => svOdditSyncHomeFeatureButton(featureSection));
      observer.observe(featureSection, { attributes: true, attributeFilter: ['class'], subtree: true });
    });
  };

  svOdditInitHomeFeatureLinks();
  document.addEventListener('shopify:section:load', (event) => svOdditInitHomeFeatureLinks(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-oddit-main-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sensic-amazon-link')) {
  let detectedCountry;
  customElements.define('sensic-amazon-link', class extends HTMLElement {
    async connectedCallback() {
      this.hidden = true;
      const link = this.querySelector('a');
      if (!link) return;
      if (document.readyState === 'loading') {
        await new Promise(resolve => document.addEventListener('DOMContentLoaded', resolve, {once:true}));
      }
      try {
        const domains = {US:'amazon.com', DE:'amazon.de', GB:'amazon.co.uk'};
        const selectedCountry = (this.dataset.country || '').toUpperCase();
        let country = domains[selectedCountry] ? selectedCountry : '';
        if (!country) {
          if (!detectedCountry) {
            const controller = new AbortController();
            const timeout = setTimeout(() => controller.abort(), 8000);
            detectedCountry = fetch((window.Shopify?.routes?.root || '/') + 'browsing_context_suggestions.json?country[enabled]=true', {credentials:'same-origin', cache:'no-store', signal:controller.signal})
              .then(response => { if (!response.ok) throw new Error('Country unavailable'); return response.json(); })
              .then(data => data.detected_values?.country?.handle?.toUpperCase() || '')
              .catch(() => '')
              .finally(() => clearTimeout(timeout));
          }
          country = await detectedCountry;
        }
        if (!domains[country] || !this.isConnected) return;
        const destination = this.dataset[country.toLowerCase()];
        if (!destination) return;
        const url = new URL(destination);
        if (url.protocol !== 'https:' || ![domains[country], 'www.' + domains[country]].includes(url.hostname)) return;
        link.href = url.href;
        this.hidden = false;
        if (country === 'US' && this.dataset.replaceUs === 'true') {
          const product = this.closest('sv-oddit-product');
          if (!product) return;
          const stickyBar = product.querySelector('[data-sv-sticky-atc]');
          if (stickyBar && !stickyBar.querySelector('[data-sv-amazon-sticky]')) {
            const stickyLink = link.cloneNode(true);
            stickyLink.setAttribute('data-sv-amazon-sticky', '');
            stickyBar.append(stickyLink);
          }
          product.classList.add('sensic-amazon-us');
          product.updateStickyVisibility?.();
        }
      } catch { this.hidden = true; }
    }
    disconnectedCallback() {
      const product = this.closest('sv-oddit-product');
      product?.classList.remove('sensic-amazon-us');
      product?.querySelector('[data-sv-amazon-sticky]')?.remove();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-oddit-signup-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sv-oddit-signup-popup')) customElements.define('sv-oddit-signup-popup', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController(); const signal = this.abort.signal;
      this.dialog = this.querySelector('dialog'); this.heading = this.querySelector('h2'); this.form = this.querySelector('form');
      this.design = !!window.Shopify?.designMode; this.key = 'sv_oddit_signup_v1'; this.started = performance.now();
      this.elapsed = Number(this.read('elapsed', true)) || 0;
      this.querySelectorAll('[data-sv-signup-close]').forEach(b => b.addEventListener('click', () => this.close(), {signal}));
      this.querySelector('[data-sv-signup-next]').addEventListener('click', () => this.step('form'), {signal});
      this.querySelector('[data-sv-signup-preview]')?.addEventListener('click', () => this.open('intro'), {signal});
      this.dialog.addEventListener('cancel', e => {e.preventDefault(); this.close();}, {signal});
      this.dialog.addEventListener('click', e => {if(e.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if(e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.close(); }}, {signal});
      this.dialog.addEventListener('close', () => {if(!this.dialog.open && !this.captchaSuspended)this.release();}, {signal});
      this.form.addEventListener('submit', e => {
        if(this.design) {e.preventDefault(); return;}
        this.write('pending', JSON.stringify({id:this.dataset.formId,scroll:window.scrollY,time:Date.now()}), true);
      }, {signal});
      document.addEventListener('visibilitychange', () => {this.tick();this.started=performance.now();}, {signal});
      window.addEventListener('pagehide', () => {this.tick();this.release();}, {signal});
      let pending; try {pending=JSON.parse(this.read('pending',true)||'null');} catch {}
      const recentPending = pending?.id===this.dataset.formId && Number.isFinite(pending.time) && Date.now()-pending.time >= 0 && Date.now()-pending.time < 600000;
      const ownAnchor = location.hash==='#'+this.dataset.formId;
      const posted = !!this.querySelector('[data-sv-signup-posted]');
      const error = this.querySelector('[data-sv-signup-error]');
      if(!this.design && (recentPending || ownAnchor && (posted || error.textContent.trim() || new URLSearchParams(location.search).get('form_type')==='customer'))) {
        this.write('pending','',true);
        this.returned=true;
        if(!ownAnchor) history.replaceState(history.state,'',location.pathname+location.search+'#'+this.dataset.formId);
        document.querySelector('[data-sv-newsletter-modal][open]')?.close();
        if(posted) {this.write('subscribed','1');this.open('success');}
        else {
          if(!error.textContent.trim()) error.textContent=error.dataset.unconfirmed;
          error.hidden=false;
          this.open('form');
        }
        if(recentPending && Number.isFinite(pending.scroll)) requestAnimationFrame(()=>window.scrollTo({top:pending.scroll,behavior:'instant'}));
      }
      this.wasVisible = !document.hidden;
      this.timer = setInterval(()=>this.tick(), 250);
    }
    read(k, session=false) {try{return (session?sessionStorage:localStorage).getItem(this.key+'_'+k);}catch{return null;}}
    write(k,v,session=false) {try{(session?sessionStorage:localStorage).setItem(this.key+'_'+k,v);}catch{}}
    tick() {
      this.syncCaptchaVisibility();
      if(this.captchaSuspended)return;
      const now=performance.now(); if(this.wasVisible)this.elapsed+=Math.min(now-this.started,1500); this.started=now;this.wasVisible=!document.hidden;
      this.write('elapsed',String(this.elapsed),true);
      if(this.design || this.dataset.enabled!=='true' || this.dataset.subscriber==='true' || document.hidden || this.dialog.open || this.shown || this.read('subscribed')==='1' || Number(this.read('dismissed'))>Date.now() || this.read('shown',true)==='1')return;
      if(this.elapsed<Number(this.dataset.delay)*1000 || this.busy())return;
      this.open('intro');this.shown=true;this.write('shown','1',true);
    }
    busy() {
      if(document.activeElement?.matches('input,textarea,select,[contenteditable="true"]'))return true;
      return [...document.querySelectorAll('dialog[open],[aria-modal="true"],.sv-oddit-search[open],.sv-oddit-header details[open],#shopify-pc__banner')].some(e=>e!==this.dialog && e.getClientRects().length && getComputedStyle(e).visibility!=='hidden');
    }
    syncCaptchaVisibility() {
      if(!this.captchaSuspended && (!this.dialog.open || this.querySelector('[data-sv-signup-step="form"]').hidden))return;
      const challenge=[...document.querySelectorAll('iframe[src*="hcaptcha.com/"][src*="frame=challenge"]')].find(frame=>{
        const box=frame.getBoundingClientRect();
        return box.width>0 && box.height>0 && box.bottom>0 && box.top<innerHeight && getComputedStyle(frame).visibility==='visible';
      });
      if(challenge && !this.captchaSuspended) {
        this.captchaSuspended=true;
        this.dialog.close();
        challenge.focus();
      } else if(!challenge && this.captchaSuspended) {
        this.captchaSuspended=false;
        this.open('form');
      }
    }
    step(name) {
      this.querySelectorAll('[data-sv-signup-step]').forEach(e=>e.hidden=e.dataset.svSignupStep!==name);
      this.heading.textContent=this.heading.dataset[name==='intro'?'intro':name==='form'?'form':'success'];
      this.heading.focus({preventScroll:true});
    }
    open(step) {
      if(!this.dialog.isConnected)return;
      clearTimeout(this.closing);this.previous=document.activeElement;this.step(step);
      if(!this.dialog.open){if(this.oldOverflow===undefined)this.oldOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';this.dialog.showModal();}
      requestAnimationFrame(()=>{this.dialog.classList.add('is-visible');this.heading.focus({preventScroll:true});});
    }
    close() {
      if(this.returned) {
        const cleanUrl=new URL(location.href);
        cleanUrl.searchParams.delete('customer_posted');
        if(cleanUrl.searchParams.get('form_type')==='customer') cleanUrl.searchParams.delete('form_type');
        if(cleanUrl.hash==='#'+this.dataset.formId) cleanUrl.hash='';
        history.replaceState(history.state,'',cleanUrl.pathname+cleanUrl.search+cleanUrl.hash);
        this.returned=false;
      }
      if(!this.design)this.write('dismissed',String(Date.now()+Number(this.dataset.days)*86400000));
      this.dialog.classList.remove('is-visible');this.closing=setTimeout(()=>this.dialog.close(),matchMedia('(prefers-reduced-motion: reduce)').matches?0:200);
    }
    release() {if(this.oldOverflow!==undefined){document.documentElement.style.overflow=this.oldOverflow;this.oldOverflow=undefined;}if(this.previous?.isConnected)this.previous.focus({preventScroll:true});}
    disconnectedCallback(){this.abort?.abort();clearInterval(this.timer);clearTimeout(this.closing);this.release();}
  });

  } catch(e) { console.error(e); }
})();
})();
